import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Mobile Safari and some browsers block SameSite=None cookies for cross-site
// requests. As a fallback we persist the access token in sessionStorage
// (cleared on tab close — safer than localStorage) and attach it as a Bearer
// header. The backend accepts both cookies AND Bearer.
api.interceptors.request.use((config) => {
  if (!config.headers["Authorization"]) {
    try {
      const token = sessionStorage.getItem("atech_access_token");
      if (token) config.headers["Authorization"] = `Bearer ${token}`;
    } catch (_e) { /* sessionStorage unavailable — cookies only */ }
  }
  return config;
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
